import { render, staticRenderFns } from "./OperatorFrame.vue?vue&type=template&id=3cab8796&"
import script from "./OperatorFrame.vue?vue&type=script&lang=js&"
export * from "./OperatorFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports